import { LabelTagArray, OptionValue } from 'types/common';
import { CreatorEnvironment, CreatorEquipment } from 'types/profile';

export enum PROFILE_TABS {
  PORTFOLIO = 'portfolio',
  ABOUT = 'about',
  PROMOTIONS = 'promotions',
  //   REVIEWS = 'reviews',
}

export const ProfileTabs: OptionValue<PROFILE_TABS> = [
  {
    value: PROFILE_TABS.PORTFOLIO,
    label: 'Portfolio',
  },
  {
    value: PROFILE_TABS.ABOUT,
    label: 'Skills & About',
  },
  {
    value: PROFILE_TABS.PROMOTIONS,
    label: 'Promotions',
  },
  //   {
  //     value: PROFILE_TABS.REVIEWS,
  //     label: 'Reviews',
  //   },
];

export const GuidanceTips = [
  'Unboxing Videos',
  'Testimonial Videos',
  'Lifestyle Photography',
  'Portrait Style Shots',
  'Product In Use Videos',
  'Product Shots',
  'Creativity',
];

export const CREATOR_EQUIPMENT = [
  'iPhone',
  'dslr',
  'tripod',
  'ingLight',
  'softboxLighting',
  'microphone',
  'customBackdrops',
  'videoSoftware',
  'photoSoftware',
  'drone',
] as const;

export const CREATOR_EQUIPMENT_TAGS: LabelTagArray<CreatorEquipment> = [
  { id: 'iPhone', label: 'iPhone' },
  { id: 'dslr', label: 'DSLR' },
  { id: 'tripod', label: 'Tripod' },
  { id: 'ingLight', label: 'Ring light' },
  { id: 'softboxLighting', label: 'Softbox or umbrella lighting' },
  { id: 'microphone', label: 'Microphone' },
  { id: 'customBackdrops', label: 'Custom backdrops' },
  { id: 'videoSoftware', label: 'Video editing software' },
  { id: 'photoSoftware', label: 'Photo editing software' },
  { id: 'drone', label: 'Drone' },
];

export const CREATOR_ENVIRONMENT = [
  'highRiseApartment',
  'modernKitchen',
  'suburbanHome',
  'suburbanBackyard',
  'desert',
  'ocean',
  'pool',
  'beach',
  'snowyWinters',
  'fallFoliage',
  'cityLife',
  'countryArea',
  'woodsyArea',
  'mountainousArea',
];

export const CREATOR_ENVIRONMENT_TAGS: LabelTagArray<CreatorEnvironment> = [
  { id: 'highRiseApartment', label: 'High rise apartment' },
  { id: 'modernKitchen', label: 'Modern kitchen' },
  { id: 'suburbanHome', label: 'Suburban home' },
  { id: 'suburbanBackyard', label: 'Suburban backyard' },
  { id: 'desert', label: 'Desert' },
  { id: 'ocean', label: 'Ocean' },
  { id: 'pool', label: 'Pool' },
  { id: 'beach', label: 'Beach' },
  { id: 'snowyWinters', label: 'Snowy winters' },
  { id: 'fallFoliage', label: 'Fall foliage' },
  { id: 'cityLife', label: 'City life' },
  { id: 'countryArea', label: 'Country area' },
  { id: 'woodsyArea', label: 'Woodsy area' },
  { id: 'mountainousArea', label: 'Mountainous area' },
];

export const DEFAULT_ABOUT_SKILLS_TEXT = {
  about:
    'Tell your creative story. Let brands know who you are and what best describes you as a creative person.',
  skills: 'Where do you shine as a creator?',
  categories: 'Cameras, phones, lights, microphones...',
  environment:
    'What environment do you live in to shoot content? Do you live by a beach? In an high-rise?',
  equipment: 'What do you use to make your content?',
};

// Promotions
export const TIER_DESCRIPTIONS = {
  silver: {
    image:
      'https://storage.cloud.google.com/verbv2.appspot.com/staticImages/levelBadgeSilver%403x.png',
    range: '0-7',
    bonus: 0,
  },
  gold: {
    image:
      'https://storage.cloud.google.com/verbv2.appspot.com/staticImages/levelBadgeGold%403x.png',
    range: '8-14',
    bonus: 10,
  },
  diamond: {
    image:
      'https://storage.cloud.google.com/verbv2.appspot.com/staticImages/levelBadgeDiamond%403x.png',
    range: '15+',
    bonus: 20,
  },
};
